import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import DateFnsUtils from "@date-io/date-fns";
import CKEditor from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

// Material-UI Core
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { blue } from "@material-ui/core/colors";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import Box from "@material-ui/core/Box";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

// Custom Component
import Legend from "../../../Legend/Legend";
import FileDropzone from "../../../FileDropzone/WorkflowFileDropzone";
import RFIFileZoneContent from ".././RFIFileZoneContent";
import AttachmentChip from "../../../Chip/AttachmentChip";

import { ckEditorToolbar } from "../../../../global/ckEditor";

import {
  getRFICategoryList,
  getRfiDuplicate,
} from "../../../../dataSource/rfi";

// Material-UI Element
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

// Custom Style
import { rfiDetailFormStyle } from "../../../../styles/jss/components/RFI/rfiDetailFormStyle";
import { CastForEducation } from "@material-ui/icons";

const CustomCheckbox = withStyles({
  root: {
    color: blue[600],
    "&$disabled": {
      color: blue[600],
    },
  },
  checked: {},
  disabled: {},
})((props) => <Checkbox color="default" {...props} />);

const useStyles = makeStyles((theme) => rfiDetailFormStyle(theme));
const store = require("store");

const RFIMaster = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    fileUploadAction,
    removeFileConfirmAction,
    viewFileAction,
    noneditViewFileAction,
    openFileManagerDialog,
  } = props;
  // Use redux data
  const submissionRFIDetailRedux = useSelector(
    (state) => state.submissionRFIDetailRedux
  );
  const {
    submissionValue,
    setSubmissionValue,
    contentEditorValue,
    setContentEditorValue,
    validate,
    validationErrors,
    rfiDuplicate,
    isNew,
    editable,
    userStageAction,
    setRfiDuplicate,
    downloadFileAction,
    getDetailsLoading,
  } = props;

  const [categoryList, setCategoryList] = useState([]);
  const [rfiDuplicateError, setRfiDuplicateError] = useState("");

  const editorConfiguration = {
    toolbar: ckEditorToolbar,
  };

  const getRFICategory = async () => {
    const response = await getRFICategoryList();
    setCategoryList(response.data);
  };

  useEffect(() => {
    const fetchRFICategoryList = async () => {
      await getRFICategory();
    };
    fetchRFICategoryList();
  }, []);

  // Handle Form Input
  const ckeditorHandleChange = (name) => (event, editor) => {
    const inputData = editor.getData();
    const data = { ...submissionValue };
    data.content = inputData;
    setContentEditorValue(inputData);
    setSubmissionValue({ ...submissionValue, ...data });
    dispatch({
      type: "ADD_RFI_SUBMISSION_VALUE",
      data: { ...submissionValue, ...data },
    });
    if (
      validationErrors.content && validationErrors.content !== "" ? true : false
    ) {
      validate({ ...submissionValue, content: inputData });
    }
  };

  const handleCheckDuplicate = async (value) => {
    if (value === "") {
      setRfiDuplicate(false);
      return;
    }
    const response = await getRfiDuplicate(value);
    if (response.data.isDuplicate) {
      setRfiDuplicate(true);
      setRfiDuplicateError("Duplicate Reference Number");
      alert(
        "Duplicate Reference Number, please choose another reference number"
      );
    } else {
      setRfiDuplicate(false);
      setRfiDuplicateError("");
    }
  };

  //Handle Date
  const handleDateFieldChange = (date, name) => {
    const data = { ...submissionValue };

    data[name] = date;
    setSubmissionValue({ ...submissionValue, ...data });
    dispatch({
      type: "ADD_RFI_SUBMISSION_VALUE",
      data: { ...submissionValue, ...data },
    });
  };
  // Handle Input
  const handleInputChange = (name, validateOnChange) => (event) => {
    const data = { ...submissionValue };
    setSubmissionValue({ ...submissionValue, [name]: event.target.value });
    dispatch({
      type: "ADD_RFI_SUBMISSION_VALUE",
      data: { ...submissionValue, ...data },
    });
    if (validateOnChange) {
      validate({ ...submissionValue, [name]: event.target.value });
    }
  };

  // Handle Checkbox
  const handleCheckboxChange = (elementName) => (event) => {
    const { checked } = event.target;
    const data = { ...submissionValue };
console.log(submissionValue)
    if (checked) {
      data.category.push(elementName);

      setSubmissionValue({ ...submissionValue, ...data });
      dispatch({
        type: "ADD_RFI_SUBMISSION_VALUE",
        data: { ...submissionValue, ...data },
      });
    } else {
      if (data.category.indexOf(elementName) > -1) {
        data.category.splice(data.category.indexOf(elementName), 1);

        setSubmissionValue({ ...submissionValue, ...data });
        dispatch({
          type: "ADD_RFI_SUBMISSION_VALUE",
          data: { ...submissionValue, ...data },
        });
      }
    }
    if (
      validationErrors.category && validationErrors.category !== ""
        ? true
        : false
    ) {
      validate({ ...submissionValue, category: data.category });
    }
  };

  const required = isNew ? "*" : "";
  const readOnlyAndDisabled = isNew || editable ? false : true;

  return (
    <Fragment>
      <Grid itemxs={12}>
        <Box border={1} borderColor={"grey.500"} className={classes.boxArea}>
          <Typography variant="subtitle1" className={classes.headerText}>
            General Information
          </Typography>
          <Divider className={classes.divider} />
          <Grid item xs={12}>
            <TextField
              className={classes.textField}
              fullWidth={true}
              id={"manual_ref_no"}
              name={"manual_ref_no"}
              label={"RFI Reference Number"}
              type="text"
              required={true}
              size="small"
              variant="outlined"
              value={submissionValue.manual_ref_no || ""}
              onChange={handleInputChange(
                "manual_ref_no",
                validationErrors.manual_ref_no &&
                  validationErrors.manual_ref_no !== ""
                  ? true
                  : false
              )}
              onBlur={() => {
                handleCheckDuplicate(submissionValue.manual_ref_no);
              }}
              InputProps={{
                readOnly: readOnlyAndDisabled,
                maxLength: 2048,
              }}
              error={
                (validationErrors.manual_ref_no &&
                  validationErrors.manual_ref_no !== "") ||
                rfiDuplicate
                  ? true
                  : false
              }
              helperText={validationErrors.manual_ref_no || rfiDuplicateError}
            />
          </Grid>
          <Grid item xs={12}>
            <Box
              border={1}
              borderRadius="borderRadius"
              borderColor={
                validationErrors.category && validationErrors.category !== ""
                  ? "error.main"
                  : "grey.400"
              }
              className={classes.checkboxArea}
            >
              <Typography variant="subtitle1">
                Category of RFI{required}
              </Typography>
              {categoryList.map((obj, index) => {
                return (
                  <FormControlLabel
                    key={index}
                    control={
                      <CustomCheckbox
                        required={true}
                        checked={
                          submissionValue.category.indexOf(obj.type_seq) > -1
                            ? true
                            : false
                        }
                        onChange={handleCheckboxChange(obj.type_seq)}
                        disabled={readOnlyAndDisabled}
                        name={String(obj.type_seq)}
                      />
                    }
                    label={obj.name}
                  />
                );
              })}
              <Typography style={{ color: "#f44336", fontSize: "0.75rem" }}>
                {validationErrors.category ? validationErrors.category : ""}
              </Typography>
            </Box>
          </Grid>
          <br />
          <Grid item xs={12}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                className={classes.textField}
                fullWidth={true}
                id={"date"}
                name={"request_date"}
                label={"Date"}
                required={true}
                format="dd/MM/yyyy"
                placeholder="DD/MM/YYYY"
                size="small"
                inputVariant="outlined"
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                value={
                  submissionValue.request_date != null
                    ? submissionValue.request_date
                    : null
                }
                onChange={(date) =>
                  handleDateFieldChange(
                    date,
                    "request_date",
                    validationErrors.request_date &&
                      validationErrors.request_date !== null
                      ? true
                      : false
                  )
                }
                error={
                  validationErrors.request_date &&
                  validationErrors.request_date !== null
                    ? true
                    : false
                }
                helperText={validationErrors.request_date}
                InputProps={{
                  readOnly: readOnlyAndDisabled,
                }}
                readOnly={readOnlyAndDisabled}
              />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              className={classes.textField}
              fullWidth={true}
              id={"drawing_ref"}
              name={"drawing_ref"}
              label={"Drawing Ref"}
              type="text"
              //	required={element.mandatory}
              size="small"
              variant="outlined"
              value={submissionValue.drawing_ref || ""}
              onChange={handleInputChange(
                "drawing_ref",
                validationErrors.drawing_ref &&
                  validationErrors.drawing_ref !== ""
                  ? true
                  : false
              )}
              error={
                validationErrors.drawing_ref &&
                validationErrors.drawing_ref !== ""
                  ? true
                  : false
              }
              helperText={validationErrors.drawing_ref}
              InputProps={{
                readOnly: readOnlyAndDisabled,
                maxLength: 255,
              }}
            ></TextField>
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              className={classes.textField}
              fullWidth={true}
              id={"specification"}
              name={"specification"}
              label={"Specification"}
              type="text"
              //	required={element.mandatory}
              size="small"
              variant="outlined"
              value={submissionValue.specification || ""}
              onChange={handleInputChange(
                "specification",
                validationErrors.specification &&
                  validationErrors.specification !== ""
                  ? true
                  : false
              )}
              error={
                validationErrors.specification &&
                validationErrors.specification !== ""
                  ? true
                  : false
              }
              helperText={validationErrors.specification}
              InputProps={{
                readOnly: readOnlyAndDisabled,
                maxLength: 2048,
              }}
            ></TextField>
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              className={classes.textField}
              fullWidth={true}
              id={"location"}
              name={"location"}
              label={"Location"}
              type="text"
              //	required={element.mandatory}
              size="small"
              variant="outlined"
              value={submissionValue.location || ""}
              onChange={handleInputChange(
                "location",
                validationErrors.location && validationErrors.location !== ""
                  ? true
                  : false
              )}
              error={
                validationErrors.location && validationErrors.location !== ""
                  ? true
                  : false
              }
              helperText={validationErrors.location}
              InputProps={{
                readOnly: readOnlyAndDisabled,
                maxLength: 2048,
              }}
            ></TextField>
          </Grid>
          <Grid item xs={12}>
            <div className={classes.textField}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  id={"anticipated_date"}
                  name={"anticipated_date"}
                  label={"Anticipated date of response"}
                  required={true}
                  format="dd/MM/yyyy"
                  placeholder="DD/MM/YYYY"
                  size="small"
                  inputVariant="outlined"
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  className={classes.datePickerField}
                  value={
                    submissionValue.anticipated_date != null
                      ? submissionValue.anticipated_date
                      : null
                  }
                  onChange={(date) =>
                    handleDateFieldChange(
                      date,
                      "anticipated_date",
                      validationErrors.anticipated_date &&
                        validationErrors.anticipated_date !== null
                        ? true
                        : false
                    )
                  }
                  error={
                    validationErrors.anticipated_date &&
                    validationErrors.anticipated_date !== null
                      ? true
                      : false
                  }
                  helperText={validationErrors.anticipated_date}
                  InputProps={{
                    readOnly: readOnlyAndDisabled,
                  }}
                  readOnly={readOnlyAndDisabled}
                />
              </MuiPickersUtilsProvider>
            </div>
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              className={classes.textField}
              fullWidth={true}
              id={"subject"}
              name={"subject"}
              label={"Subject"}
              type="text"
              //	required={element.mandatory}
              size="small"
              variant="outlined"
              value={submissionValue.subject || ""}
              onChange={handleInputChange(
                "subject",
                validationErrors.subject && validationErrors.subject !== ""
                  ? true
                  : false
              )}
              error={
                validationErrors.subject && validationErrors.subject !== ""
                  ? true
                  : false
              }
              helperText={validationErrors.subject}
              // InputProps={{
              InputProps={{
                readOnly: readOnlyAndDisabled,
                maxLength: 2048,
              }}
            ></TextField>
          </Grid>
          <Grid item xs={12}>
            <Legend id="general-content" label="RFI CONTENT*">
              <Box
                border={
                  validationErrors.content && validationErrors.content !== ""
                    ? 1
                    : 0
                }
                borderColor={
                  validationErrors.content && validationErrors.content !== ""
                    ? "error.main"
                    : "grey.500"
                }
              >
                <CKEditor
                  editor={ClassicEditor}
                  data={contentEditorValue}
                  fullWidth={true}
                  id={"content"}
                  name={"content"}
                  onChange={ckeditorHandleChange("content")}
                  config={editorConfiguration}
                  disabled={readOnlyAndDisabled}
                />
              </Box>
              {validationErrors.content && validationErrors.content !== "" ? (
                <Typography
                  variant="caption"
                  color="error"
                  className={classes.errorMsg}
                >
                  {validationErrors.content}
                </Typography>
              ) : (
                ""
              )}
            </Legend>
          </Grid>
          {isNew || editable ? (
            <Grid item xs={12}>
              <div className={classes.fileUploadBtnArea}>
                <Legend id="attachment" label="ATTACHMENT">
                  <Box className={classes.addFileBtnArea}>
                    <FileDropzone
                      key={"rfi_attachment"}
                      title={""}
                      fileType={"rfi_attachment"}
                      disabled={false}
                      editable={editable}
                      isNew={isNew}
                      fileUploadAction={fileUploadAction}
                      fileRemoveAction={removeFileConfirmAction}
                      viewFileAction={viewFileAction}
                      DropzoneContent={RFIFileZoneContent}
                      openFileManagerDialog={openFileManagerDialog}
                    />
                  </Box>
                </Legend>
              </div>
            </Grid>
          ) : (
            <Legend id="file_attachment" label="ATTACHMENTS">
              {userStageAction.IS_ATTACHMENT_READABLE === "Y" ||
              submissionValue.is_draft === "Y" ? (
                <div className={classes.messageAttachmentArea}>
                  <Grid item xs={12}>
                    {submissionValue.rfi_attachments.length > 0 ? (
                      submissionValue.rfi_attachments.map((obj, index) => {
                        return (
                          <AttachmentChip
                            key={obj.file_seq}
                            id={obj.file_seq}
                            filename={obj.filename}
                            fileSize={obj.filesize}
                            fileExtension={obj.extension}
                            viewFileAction={() =>
                              noneditViewFileAction("rfi", obj.atth_seq)
                            }
                            downloadFileAction={() =>
                              downloadFileAction("rfi", obj.atth_seq)
                            }
                            fileRemoveAction={null}
                          />
                        );
                      })
                    ) : (
                      <h3 style={{ color: "red" }}>No attchments</h3>
                    )}
                  </Grid>
                </div>
              ) : (
                <h3 style={{ color: "red" }}>
                  You have no permission to read file attachments
                </h3>
              )}
            </Legend>
          )}
        </Box>
      </Grid>
    </Fragment>
  );
};

export default RFIMaster;
